/**
 * Navigation utilities for handling smooth scrolling and route navigation
 */

/**
 * Scroll to a section on the current page
 * @param {string} sectionId - The ID of the section to scroll to
 * @param {number} offset - Offset from top in pixels (default: 80)
 */
export function scrollToSection(sectionId, offset = 80) {
  const element = document.getElementById(sectionId);
  if (element) {
    const elementTop = element.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({ 
      top: Math.max(0, elementTop - offset), 
      behavior: 'smooth' 
    });
  }
}

/**
 * Handle navigation to sections - works for both same page and cross-page navigation
 * @param {string} href - The href (can be a section ID or full path)
 * @param {Function} navigate - React Router navigate function
 * @param {boolean} isHomePage - Whether currently on home page
 */
export function handleSectionNavigation(href, navigate, isHomePage) {
  // If it's a full path (starts with /), navigate directly
  if (href.startsWith('/')) {
    navigate(href);
    return;
  }

  // If on home page, scroll to section
  if (isHomePage) {
    scrollToSection(href);
  } else {
    // Navigate to home with scrollTo parameter
    navigate(`/?scrollTo=${href}`);
  }
}